import type { Lang } from "../types.ts";
import { PAGES } from "../i18n/pages.ts";
import type { InfoPageId } from "../i18n/pages.ts";

/** Renders one of the static help/tips/support/imprint pages. */
export function InfoPage({ page, lang }: { page: InfoPageId; lang: Lang }) {
  const content = PAGES[lang][page] ?? PAGES.de[page];

  return (
    <article className="info">
      <h2 className="info__title">{content.title}</h2>
      {content.sections.map((section, i) => (
        <section key={i} className="info__section">
          {section.heading && <h3>{section.heading}</h3>}
          {section.body.map((block, j) =>
            Array.isArray(block) ? (
              <ul key={j}>
                {block.map((line, k) => (
                  <li key={k}>{line}</li>
                ))}
              </ul>
            ) : (
              <p key={j}>{block}</p>
            )
          )}
        </section>
      ))}
    </article>
  );
}
